import React from 'react';
import ChevronRight from '@/assets/images/chevron-right.svg';
import { DMImage } from '@/components/custom-image/custom-image';
import { DMLink } from '@/components/link';
import { Badge } from '@/components/ui/badge';
import { SheetClose } from '@/components/ui/sheet';
import { cn } from '@/lib/utils';

type MenuProps = {
  href: string;
  menuName: string;
  menuIcon?: string;
  variant?: 'primary' | 'secondary' | 'primary_outline' | 'bgthird' | 'text';
  className?: string;
  extra?: string;
  comingSoon?: boolean;
};

function Menu({ href, menuName, menuIcon, variant, className, extra, comingSoon }: MenuProps) {
  return (
    <DMLink
      href={href}
      variant={variant}
      className={cn('w-full px-0 py-0', {
        'pointer-events-none': comingSoon,
      })}
    >
      <SheetClose
        className={`w-full flex justify-center items-center font-semibold   hover:bg-slate-800  rounded-md gap-3 ${className}`}
      >
        <div className={`flex gap-4 w-full items-center ${extra}`}>
          {menuIcon && <DMImage src={menuIcon} alt='Home Icon' width={24} height={24} />}
          {menuName}
        </div>

        {comingSoon ? (
          <Badge className='bg-brand-primary-border shrink-0'>Coming soon</Badge>
        ) : (
          variant === 'text' && (
            <DMImage src={ChevronRight} alt='Home Icon' width={24} height={24} />
          )
        )}
      </SheetClose>
    </DMLink>
  );
}

export default Menu;
